
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner-program",
      function () {
        return require("private-next-pages/partner-program.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner-program"])
      });
    }
  